import { Controller } from "@hotwired/stimulus"

// Show/hide columns on the meetings list. Each header + body cell carries a
// data-col="key"; toggling a checkbox adds/removes Tailwind's `hidden` on
// every matching cell. Choices persist per user in localStorage and re-apply
// after turbo-frame reloads (search). Default: the "#" column starts hidden.
const KEY = "meetings.hiddenColumns"
const DEFAULT_HIDDEN = ["num"]

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this._apply()
    this._onFrameLoad = () => this._apply()
    // Re-apply once the results turbo-frame swaps in fresh rows (search).
    document.addEventListener("turbo:frame-load", this._onFrameLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this._onFrameLoad)
  }

  toggle(event) {
    const col = event.target.value
    let hidden = this._hidden()
    if (event.target.checked) {
      hidden = hidden.filter((c) => c !== col)
    } else if (!hidden.includes(col)) {
      hidden.push(col)
    }
    this._store(hidden)
    this._apply()
  }

  _hidden() {
    try {
      const raw = JSON.parse(window.localStorage.getItem(KEY))
      return Array.isArray(raw) ? raw : DEFAULT_HIDDEN.slice()
    } catch (e) {
      return DEFAULT_HIDDEN.slice()
    }
  }

  _store(hidden) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(hidden))
    } catch (e) {
      // storage disabled — column state just won't persist
    }
  }

  _apply() {
    const hidden = this._hidden()
    this.element.querySelectorAll("[data-col]").forEach((cell) => {
      cell.classList.toggle("hidden", hidden.includes(cell.dataset.col))
    })
    this.checkboxTargets.forEach((cb) => {
      cb.checked = !hidden.includes(cb.value)
    })
  }
}
